<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">Designation Wise Detail Data</div>
            <div class="col-auto"><span class="badge view" style="font-size: larger;height: auto;">Total:
                    {{this.TotalCount}}</span></div>
        </div>
    </div>
    <div class="card-body">
        <!-- <input mdbCheckbox class="form-check-input" style="height: 15px; width: 15px; font-weight: bold;" name="header"
            type="checkbox" (change)="toggleSelect()" [(ngModel)]="selectcheck" value="" />&nbsp;&nbsp;<label
            style="font-weight: bold; font-size: 14px;">Include All Transactions</label> -->
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <label class="small-light-label heading">Branch Name</label><br />
                    <label class="Label1">{{InputData.Branch}}</label>
                </div>
                <div class="col-md-4">
                    <label class="small-light-label heading">Client Name</label><br />
                    <label class="Label1">{{InputData.Client}}</label>
                </div>
                <div class="col-md-4">
                    <label class="small-light-label heading">Site Name</label><br />
                    <label class="Label1">{{InputData.Site}}</label>
                </div>
            </div>
            <hr />
            <div class="row">
                <div class="col-md-4">
                    <label class="small-light-label heading" [autofocus]="true">Designation Name</label><br />
                    <label class="Label1">{{InputData.Designation}}</label>
                </div>
                <div class="col-md-4">
                    <label class="small-light-label heading">Duty Name</label><br />
                    <label class="Label1">{{InputData.DutyName}}</label>
                </div>
                <div class="col-md-4">
                    <label class="small-light-label heading">Shift Name</label><br />
                    <label class="Label1">{{InputData.Shift}}</label>
                </div>
            </div>
            <hr>
            <div class="card-body p-1" style="overflow: auto;">
                <table datatable class="customeDatatable table table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" [ngClass]="{'colHide': !this.common.PageRight.IsView}">Edit</th>
                            <th scope="col">EntryNo</th>
                            <th scope="col">WO.No.</th>
                            <th scope="col">WODate</th>
                            <!-- <th scope="col">BranchName</th>
                            <th scope="col">ClientGroupName </th>
                            <th scope="col">SiteName</th> -->
                            <th scope="col">From Date</th>
                            <th scope="col">To Date</th>
                            <th scope="col">Allocation</th>
                            <th scope="col">NoOfPerson</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let element of Data; let i = index">
                            <th scope="row" [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{ i + 1 }}
                            </th>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O','colHide': !this.common.PageRight.IsEdit}">
                                <button #edit type="button" class="btn btn-sm btn-outline-primary btn-custom-small"
                                    (click)="Edit(element)">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                            </td>
                            <td class="right-align" [ngClass]="{'highlight-row': element.AllocationType === 'O'}">
                                <span class="no-of-person">{{element.EntryNo}}
                                </span>
                            </td>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.WONo}}</td>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.WODate}}</td>
                            <!-- <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.BranchName}}
                            </td>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">
                                {{element.ClientGroupName}}
                            </td>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.SiteName}}
                                &nbsp;
                                <span *ngIf="element.AllocationType === 'O'"
                                    style="color: rgb(221, 119, 24);">(OP)</span>
                                <span *ngIf="element.IsAutoReduction" style="color:rgb(4, 178, 231)">(AUTO)</span>
                            </td> -->
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.FromDate}}</td>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.ToDate}}</td>
                            <td [ngClass]="{'highlight-row': element.AllocationType === 'O'}">{{element.AllocationType}}<span *ngIf="element.IsAutoReduction">(Auto Entry)</span></td>
                            <td class="right-align" [ngClass]="{'highlight-row': element.AllocationType === 'O'}">
                                <span *ngIf="element.AllocationType === 'R'">-</span>
                                <span *ngIf="element.AllocationType === 'A' || element.AllocationType === 'O'">+</span>
                                <span class="no-of-person">{{ element.NoOfPerson }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                    <input type="text" class="inputh" (focus)="'true'" autofocus style="width: 0;height: 0;border-width: 0;" #myControl/>
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()"
                    style="visibility: hidden;">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
                &nbsp; <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Cancel()"
                    autofocus="true" #cancelButton id="cancelButton">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>
